// @flow
import React, { Component } from 'react';

import Diagnostics from 'view/Pages/StatusPage/Diagnostics';
import ProductDetails from 'view/Pages/StatusPage/ProductDetails';
import ServerStateControls from 'view/Pages/StatusPage/ServerStateControls';
import Account from 'view/Pages/LicensesPage/Account';

export default class StatusPage extends Component<{}> {
  render() {
    return (
      <div className="page page-contents status-page">
        <ServerStateControls />
        <ProductDetails />
        <Account />
        <Diagnostics />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/StatusPage/StatusPage.js